// extracted by mini-css-extract-plugin
module.exports = {"zuzLogo":"RegisteredUserHeader_zuzLogo__3ra_I"};